var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverallWordmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 410.947,
    height: 64,
    viewBox: "0 0 410.947 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OVER/LL"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M382.118 1.00494V51.6018H410.947V62.073H369.727V1.00494H382.118Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M321.707 1.00494V51.6018H350.536V62.073H309.316V1.00494H321.707Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M283.678 2.26139H289.212L272.196 63.2457H266.661L283.678 2.26139Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M215.968 37.8636V62.073H203.577V1.00494H235.876C240.998 1.00494 244.797 2.34525 247.523 5.19342C250.415 8.20913 252.067 12.6489 252.067 17.5076C252.067 24.9631 248.68 29.9055 241.906 32.5861C249.589 35.9369 249.919 36.7746 250.249 54.7851C250.249 57.4657 250.993 58.7222 252.893 59.8112V62.073H239.593C238.106 59.1411 237.776 57.3819 237.776 51.6018C237.776 50.6803 237.776 49.1725 237.859 47.5809V45.0678C237.859 40.0416 235.546 37.8636 230.176 37.8636H215.968ZM215.968 27.3924H230.92C234.472 27.3924 236.041 26.9735 237.446 25.8008C238.932 24.5442 239.676 22.1987 239.676 19.2667C239.676 16.4186 238.932 14.3243 237.446 13.0678C235.876 11.8112 234.472 11.4761 230.92 11.4761H215.968V27.3924Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M150.876 35.7693V51.6018H183.505V62.073H138.485V1.00494H182.018V11.4761H150.876V25.2981H179.705V35.7693H150.876Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M100.712 62.073H90.2214L69.9005 1.00494H82.3739L95.756 46.9945L108.89 1.00494H121.364L100.712 62.073Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28.9119 0C37.6681 0 44.2765 2.68063 49.5633 8.46073C54.9326 14.2408 57.989 22.8691 57.989 32.4188C57.989 41.0471 54.7674 49.9267 49.5633 55.5393C44.3591 61.2356 37.5855 64 28.9945 64C20.4035 64 13.6299 61.2356 8.42575 55.5393C3.0564 49.7592 0 41.1309 0 32C0 22.8691 3.0564 14.3246 8.42575 8.46073C13.5473 2.84817 20.4861 0 28.9119 0ZM28.9945 10.7225C18.9166 10.7225 12.3908 19.0995 12.3908 32C12.3908 44.9005 18.9166 53.2775 28.9945 53.2775C38.9072 53.2775 45.5982 44.9005 45.5982 32.3351C45.5982 19.0995 39.155 10.7225 28.9945 10.7225Z",
    fill: "#0D0907"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallWordmark);
export default __webpack_public_path__ + "static/media/overall-wordmark.514e0473b04528942be044ae70df9430.svg";
export { ForwardRef as ReactComponent };